// Return types can be passed to restrictToLoggedIn to specify
// SISU's behavior when given a returnTo
export enum LoggedOutReturnType {
  // returnTo only applies for new joins, logins ignore returnTo
  JOIN_ONLY = 'join_only',
}
